<!-- Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein. -->
<style scoped>
.answerItem {
  display: block;
  max-width: 9.75rem;
  width: 80%;
  padding: 0.625rem 0;
  margin: 1.25rem 0.25rem;
  cursor: pointer;
}

.answerItem.selected,
.answerItem.disabled {
  cursor: auto;
}

.answerImage {
  display: flex;
  position: relative;
}

.answerImage img {
  display: block;
  width: 100%;
  height: 100%;
}

.answerItem.disabled .selector,
.selected .answerImage .selector {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(126, 120, 133, 0.7);
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.selected .answerImage .selector img {
  width: 1.625rem;
  height: auto;
  display: inline-block;
}

.template3wrapper h2 {
  font-size: 1.5rem;
  font-weight: 500;
  text-align: center;
  color: #333333;
  text-transform: none;
}

.template3wrapper h3 {
  font-size: 0.875rem;
  font-weight: 500;
  text-align: center;
  color: #7e7885;
  padding: 0.5625rem 0 0 0;
  text-transform: none;
}

.answersWrapper {
  margin: 1.875rem 0 0 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

@media (max-width: 576px) {
    .answersWrapper {
      flex-wrap: wrap;
      justify-content: center;
  }
}

.answersWrapper::before {
  content: "";
}

.answersWrapper::after {
  content: "";
}

.template3wrapper h5 {
  font-size: 1.125rem;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #7e7885;
  margin-top: 1.25rem;
  text-transform: none;
}

.template3wrapper h6 {
  font-size: 0.8rem;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #7e7885;
  margin-top: 1.25rem;
  text-transform: none;
}

.osf-q3-framed-image {
  border: 0.7rem groove gold;
}
</style>

<template>
    <div class="template3wrapper">
        <h2>{{ question.title }}</h2>
        <h3>{{ question.subTitle }}</h3>

        <div class="answersWrapper">
            <div
                v-for="answer in this.answers"
                :key="answer.id"
                class="answerItem"
                v-bind:class="[
                    answer.selected ? 'selected' : '',
                    answer.disabled ? 'disabled' : '',
                ]"
                :title="answer.text"
                v-on:click="selectAnswer(answer.id)"
            >
                <div class="answerImage osf-q3-framed-image">
                    <div class="selector">
                        <img
                            v-show="!answer.disabled"
                            :src="images.checkmark"
                        >
                    </div>
                    <img :src="getAnswerImage(answer)">
                </div>

                <h5>{{ answer.title }}</h5>
                <h6>{{ answer.subTitle }}</h6>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Q3Template',
    computed: {
        question: function () {
            return this.$store.state.questionData;
        },
        answers: function () {
            return this.$store.state.questionData.answers;
        },
        images: function () {
            return this.$store.state.quizData.images;
        }
    },
    methods: {
        selectAnswer: function (aid) {
            this.$store.commit('setAnswer', aid);
        },
        getAnswerImage: function (answer) {
            if (answer.image && answer.image !== ' ') {
                return answer.image;
            }
            return this.images.noImage;
        }
    }
};
</script>
